import { AccessHandlerTranslation } from 'locales/de/pages/Access-Handler/accessHandler';

const en: AccessHandlerTranslation = {
  title: 'Access control'
};

export default en;
